<template>
  <v-parallax id="home" src="/img/bg.jpg">
    <v-container fluid>
      <v-container>
        <v-row align="center" style="min-height: 80vh;">

          <v-col class="cont-info-viewport pa-4 mx-auto text-center" cols="12" sm="12" md="12" lg="8" xxl="6">
            <p class="text-h4 text-grey-lighten-2 mb-2">Bienvenido, somos</p>
            <h1 class="mb-4 title">QuillQuest <br><span>Digital Agency</span></h1>
            <p class="mb-4 text-body-1">Tu puerta a la innovación digital. Nos especializamos en transformar
              marcas con servicios
              de vanguardia en diseño web, SEO, marketing de contenido y más. Juntos, elevaremos tu presencia online y
              conectaremos tu mensaje con el mundo. ¡Comienza tu viaje digital con nosotros hoy!</p>
            <v-btn
              href="https://api.whatsapp.com/send?phone=+573174361131&text=Hola%20QuillQuest,%20necesito%20de%20tu%20ayuda%20con:%20"
              rel="noopener" target="_blank" size="x-large" block>Contactar
              <template v-slot:append>
                <v-icon color="green" icon="mdi-arrow-right-thick"></v-icon>
              </template>
            </v-btn>
            <!--         <HelloWorld class="text-blue-lighten-3" msg="Welcome to Your Vue.js App" /> -->
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </v-parallax>
  <v-container fluid id="services">
    <v-container>
      <v-row align="center">
        <v-col cols="12">
          <h2>Nuestros Servicios</h2>
        </v-col>
        <v-col cols="12" xs="6" sm="6" md="4" lg="4" xl="4">
          <v-card class="mx-auto" prepend-icon="mdi-account-multiple-check" title="UX/UI Design">
            <v-card-text>
              Potencia tu sitio con UX/UI que cautiva. Diseños intuitivos y experiencias únicas. ¡Haz que tus
              usuarios amen tu marca!
            </v-card-text>

          </v-card>
        </v-col><v-col cols="12" xs="6" sm="6" md="4" lg="4" xl="4">
          <v-card class="mx-auto" prepend-icon="mdi-cash-lock" title="E-Commerce">
            <v-card-text>Impulsa tu negocio online con nuestro desarrollo e-commerce a medida.
              Soluciones rápidas, seguras y escalables. ¡Vende más, ahora!</v-card-text>

          </v-card>
        </v-col><v-col cols="12" xs="6" sm="6" md="4" lg="4" xl="4">
          <v-card class="mx-auto" prepend-icon="mdi-monitor-cellphone-star" title="Web Development">
            <v-card-text>Da vida a tu proyecto en la web con desarrollo a medida, rápido y efectivo.
              ¡Destaca en línea con soluciones personalizadas!</v-card-text>

          </v-card>
        </v-col><v-col cols="12" xs="6" sm="6" md="4" lg="4" xl="4">
          <v-card class="mx-auto" prepend-icon="mdi-google-analytics" title="SEO Optimization">
            <v-card-text>Escala posiciones en Google con nuestra optimización SEO. Aumenta tu
              visibilidad y tráfico. ¡Convierte más con menos esfuerzo!</v-card-text>

          </v-card>
        </v-col>
        <v-col cols="12" xs="6" sm="6" md="4" lg="4" xl="4">
          <v-card class="mx-auto" prepend-icon="mdi-palette-advanced" title="Brand Design">
            <v-card-text>Creamos marcas memorables que resuenan y perduran. Diseño de marca que
              captura esencia y propósito. ¡Deja huella con nosotros</v-card-text>

          </v-card>
        </v-col>
        <v-col cols="12" xs="6" sm="6" md="4" lg="4" xl="4">
          <v-card class="mx-auto" prepend-icon="mdi-tag-faces" title="Social Media">
            <v-card-text>Impulsa tu presencia online con un manager de social media experto.
              Estrategias personalizadas para conectar y crecer. ¡Destaca ya!</v-card-text>

          </v-card>
        </v-col>

        <v-col cols="12">
          <v-col class="mx-auto" cols="12" md="6" sm="6">
            <v-btn
              href="https://api.whatsapp.com/send?phone=+573174361131&text=Hola%20QuillQuest,%20necesito%20de%20tu%20ayuda%20con:%20"
              rel="noopener" target="_blank" size="x-large" prepend-icon="mdi-whatsapp" block>enviar mensaje</v-btn>
          </v-col>
        </v-col>

      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12">
          <h2>Más de nuestra oferta</h2>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="12" lg="6">
          <otherServicesTwo />
        </v-col>
        <v-col cols="12" lg="6">
          <otherServices />
        </v-col>

      </v-row>
    </v-container>
  </v-container>
  <section id="projects">
    <v-container fluid>
      <v-container>
        <v-row>
          <v-col cols="12" class="mx-auto">
            <h2>Algunos proyectos</h2>
          </v-col>
          <v-col cols="12">
            <tabProject />
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </section>
  <v-container fluid id="trustus">
    <v-container>
      <v-row>
        <v-col cols="12" class="mx-auto">
          <h2>Han confiado en nosotros</h2>
        </v-col>

      </v-row>

      <v-row class="cont-logos align-center">
        <Carousel />
      </v-row>

    </v-container>
  </v-container>
</template>
<script>


import tabProject from '../components/tabProjects.vue'
import otherServices from '../components/otherServices.vue'
import otherServicesTwo from '../components/otherServicesTwo.vue'
import Carousel from '../components/carousel.vue'

export default {
  name: 'homePage',
  components: {
    tabProject,
    otherServices,
    otherServicesTwo,
    Carousel,
  },


}
</script>
